import { useNotify, useQuery } from "react-admin";
import { useHistory } from "react-router-dom";
import { httpClient } from "../../api/httpClient";
import { getFieldErrors } from "../../api/getValidationErrors";
import { useNotifyError } from "../../utils/notifiers/useNotifyError";
import React from "react";

export const useOnSubmit = (url, method, basePath, orderRecord) => {
	const history = useHistory();
	const notify = useNotify();
	const notifyError = useNotifyError();

	// TODO use modified useMutateForm to handle form submission instead
	const onSubmit = React.useCallback(async (values, redirectTo) => {
		values.order_id = orderRecord?.id;
		values.terminal_id = orderRecord?.terminal_id;
		// fix for on delete all articles
		if (values.articles === null) {
			values.articles = [];
		}
		try {
			await httpClient(url, {
				method: method,
				body: JSON.stringify(values),
			}).then((response) => {
				if (Number.isInteger(values.action)) {
					history.push(basePath);
					notify("osfc.notification.finished", "info");
				} else {
					if (method === "POST") {
						history.push(`${basePath}/${response.json.id}`);
						notify("ra.notification.created", "info");
					} else {
						notify("ra.notification.updated", "info", { smart_count: 1 });
					}
				}
			});
		} catch (error) {
			const fieldErrors = getFieldErrors(error);
			if (Object.keys(fieldErrors).length > 0) {
				notify("ra.notification.bad_item", "error");
				return fieldErrors;
			} else {
				notifyError(error);
			}
		}
	}, [url, method, basePath, orderRecord]);

	return onSubmit;
};

export const useGetOrder = (orderId) => {
	return useQuery({
		type: "getOne",
		resource: "orders",
		payload: { id: orderId },
	});
};
